@if (hasAccess && userGroup) {
  <div class="padding">
    <h1 class="left-box">{{userGroup?.name ?? ""}}</h1>
    <mat-card>
        <mat-card-content>
          <div class="flex-container">
            <span class="flex-item bold">{{ 'common.labels.billingCentre2' | transloco }}</span>
            <span class="flex-item-2">{{ userGroup!.billingDetails.name }}</span>
            <span class="flex-item bold">{{ 'management.configuration' | transloco }}</span>
            <span class="flex-item-2">{{ userGroup!.configurationDetails.name }}</span>
          </div>
          <div class="flex-container">
            <span class="flex-item bold">{{ 'management.phone' | transloco }}</span>
            <span class="flex-item-2">{{ userGroup!.contactDetails.phoneNumber }}</span>
            <span class="flex-item bold">{{ 'management.fax' | transloco }}</span>
            <span class="flex-item-2">{{ userGroup!.contactDetails.faxNumber }}</span>
          </div>
          <div class="flex-container">
            <span class="flex-item bold">{{ 'management.address' | transloco }}</span>
            <span class="flex-item-2">
              {{ userGroup!.contactDetails.address.streetNumber }} {{ userGroup!.contactDetails.address.streetName }}<br/>
              {{ userGroup!.contactDetails.address.city }}, {{ userGroup!.contactDetails.address.jurisdiction }}<br/>
              {{ userGroup!.contactDetails.address.postalCode }}
            </span>
            <span class="flex-item bold">{{ 'common.labels.email2' | transloco }}</span>
            <span class="flex-item-2">{{ userGroup!.contactDetails.email }}</span>
          </div>
          <!-- <h3>Contact Information</h3>
          <app-client-contact-details-card *ngIf="userGroup != null" [contactDetails]="userGroup!.contactDetails"></app-client-contact-details-card>
          <div class="flex-container">
            <span class="spacer"></span>
            <button mat-raised-button (click)="updateUserGroupDetails()" color="accent" class="apply-padding" aria-label="Update Contact Details button">
              Save Changes
            </button>
          </div> -->
        </mat-card-content>
    </mat-card>
    <mat-divider></mat-divider>
    <app-users-list [userGroup]="this.userGroup" ></app-users-list>
    <!-- <mat-divider></mat-divider> -->
    <!-- <app-manage-user-group-access [userGroup]="userGroup"></app-manage-user-group-access> -->
  </div>
}